import { ApiResponse, getRequest } from "@/data/apiClient";

export interface SsoProvider {
  id: string;
  title: string;
  usernameField: string;
}

export type ssoProvidersResponse = Array<SsoProvider>;

export const getSsoProviders = (): Promise<ApiResponse<ssoProvidersResponse>> =>
  getRequest("sso", {});
